import React from "react"; // Importação necessária para JSX
import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";
import { isString } from "lodash";

const toastError = (err) => {
	const errorMsg = err.response?.data?.error;

	// Configurações básicas do toast
	const baseToastOptions = {
		autoClose: 7000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: false,
		progress: undefined,
		theme: "light",
		className: "", // Sem classe, pois usamos estilos inline
		bodyStyle: {
			textAlign: "center", // Centraliza o texto
			fontSize: "16px", // Aumenta o tamanho da fonte
			fontWeight: 400, // Destaca o texto
			color: "#721c24", // Texto vermelho escuro
		},
		style: {
			borderRadius: "12px", // Arredonda os cantos
			boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", // Adiciona sombra leve
			backgroundColor: "#f8d7da", // Fundo veAn error occurred!rmelho claro
			padding: "12px", // Espaçamento interno
		},
		progressStyle: {
			//transform: "scaleX(+1)", // Inverte a direção da barra de progresso
			background: "#721c24", // Cor verde para a barra de progresso
			transformOrigin: "right", // Garante que a inversão aconteça no centro
		},
	};

	// Verifica se há um erro específico vindo do backend
	if (errorMsg) {
		if (i18n.exists(`backendErrors.${errorMsg}`)) {
			toast.error(i18n.t(`backendErrors.${errorMsg}`), {
				...baseToastOptions,
				toastId: errorMsg,
			});
			return;
		} else {
			toast.error(errorMsg, {
				...baseToastOptions,
				toastId: errorMsg,
			});
			return;
		}
	}

	// Verifica se o erro é uma string
	if (isString(err)) {
		toast.error(err, {
			...baseToastOptions,
		});
		return;
	}

	// Mensagem padrão para erros desconhecidos
	toast.error(
		<div>
			Ocorreu um erro desconhecido de forma inesperada.
			<br />
			<br />
			Entre em contato com suporte.
			<br />
		</div>,
		{
			...baseToastOptions,
		}
	);
};

export default toastError;
